// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*html {
    transform: perspective(1px);
}*/

.main-container {
    min-height: 100vh;
}

#page1-main-grid {
    max-width: 250px;
    backdrop-filter: blur(4px);
    background-color: rgba(255, 255, 255, 0.55);
    padding: 10px;
    border-radius: 10px;
    align-self: center;
}

/*.reg-form .input-with-validation {
    margin-bottom: 20px;
}*/

#page2-main-wrapper {
    
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    
    max-width: 350px;
    overflow:hidden;
}

#header-image {
    width: 101%;
    height: auto;
    display: block;
    margin: 0;
    padding: 0;
}
#page2-main-image {
    width: 101%;
    min-width: 220px;
}

#discount-row-2 {
    background: #454B69;
    padding-bottom: 1px;
}

#discount-row-1 {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    border-radius: 16px 16px 0px 0px;
    align-items: center;
    background: linear-gradient(180deg, rgba(17, 31, 99, 0.65) 0%, rgba(17, 31, 99, 0.65) 100%);
    box-shadow: 0px -8px 26px 0px rgba(143, 64, 64, 0.50);
}
#discount-wrapper {
    color: #fff;
    position: fixed;
    bottom: -1px;
    width: 101%;
    max-width: 350px;
    backdrop-filter: blur(5px);
   /* transform: perspective(1px);*/
    padding-top: 8px;
/*    flex-direction: column;
    justify-content: center;*/
    align-items: center;
    
}


#price {
    opacity: 0.9;
    color: #FFF;
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

div#discount-row-2-1 {
    text-align: justify;
    padding: 8px;
}

div#discount-row-2-2 {
    display: flex;
    justify-content: space-between;
    padding: 8px;
}

#go-to-site {
    border-radius: 50px;
    background:  #31B02E;
    display: flex;
    height: 32px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

    #go-to-site.disabled {
        cursor: not-allowed;
        pointer-events: none;
        background: #31b02ea8;
        color: #ffffff91;
    }

@keyframes beat {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
}

#go-to-site.beatAnimation {
    animation: beat 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55) 1;
    animation-delay: 0.5s;
}

input#discount-code {
    border-radius: 50px;
    height: 32px;
    width: 100%;
    padding: 0px 16px;
}

div#discount-code-submit {
    height: 32px;
    border: 1px solid #fff;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 16px;
    margin-top: 2px;
    margin-left: 8px;
    cursor: pointer;
}

@media screen and (max-width: 767px) {
 



    .reg-form input {
        height: 30px;
    }

    .passwordEye {
        top: 7px;
    }



    #page2-main-wrapper, #discount-wrapper {
        max-width: 600px;
    }
}
#discount-code::-webkit-outer-spin-button,
#discount-code::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

#discount-code[type=number] {
    -moz-appearance: textfield;
    appearance:textfield;
}

@media only screen and (max-width: 374px) {
    .reg-form {
        padding: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./Content/css/phf.css"],"names":[],"mappings":";AAGA;;EAEE;;AAEF;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;EAEE;;AAEF;;IAEI,SAAS;IACT,UAAU;IACV,sBAAsB;;IAEtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,SAAS;IACT,UAAU;AACd;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,2FAA2F;IAC3F,qDAAqD;AACzD;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,0BAA0B;GAC3B,gCAAgC;IAC/B,gBAAgB;AACpB;6BAC6B;IACzB,mBAAmB;;AAEvB;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;IAEI;QACI,mBAAmB;QACnB,oBAAoB;QACpB,qBAAqB;QACrB,gBAAgB;IACpB;;AAEJ;IACI,WAAW,mBAAmB,EAAE;IAChC,MAAM,qBAAqB,EAAE;AACjC;;AAEA;IACI,4DAA4D;IAC5D,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;;IAKI;QACI,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;;;;IAIA;QACI,gBAAgB;IACpB;AACJ;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["\r\n@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap');\r\n\r\n/*html {\r\n    transform: perspective(1px);\r\n}*/\r\n\r\n.main-container {\r\n    min-height: 100vh;\r\n}\r\n\r\n#page1-main-grid {\r\n    max-width: 250px;\r\n    backdrop-filter: blur(4px);\r\n    background-color: rgba(255, 255, 255, 0.55);\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    align-self: center;\r\n}\r\n\r\n/*.reg-form .input-with-validation {\r\n    margin-bottom: 20px;\r\n}*/\r\n\r\n#page2-main-wrapper {\r\n    \r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    \r\n    max-width: 350px;\r\n    overflow:hidden;\r\n}\r\n\r\n#header-image {\r\n    width: 101%;\r\n    height: auto;\r\n    display: block;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n#page2-main-image {\r\n    width: 101%;\r\n    min-width: 220px;\r\n}\r\n\r\n#discount-row-2 {\r\n    background: #454B69;\r\n    padding-bottom: 1px;\r\n}\r\n\r\n#discount-row-1 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 8px;\r\n    border-radius: 16px 16px 0px 0px;\r\n    align-items: center;\r\n    background: linear-gradient(180deg, rgba(17, 31, 99, 0.65) 0%, rgba(17, 31, 99, 0.65) 100%);\r\n    box-shadow: 0px -8px 26px 0px rgba(143, 64, 64, 0.50);\r\n}\r\n#discount-wrapper {\r\n    color: #fff;\r\n    position: fixed;\r\n    bottom: -1px;\r\n    width: 101%;\r\n    max-width: 350px;\r\n    backdrop-filter: blur(5px);\r\n   /* transform: perspective(1px);*/\r\n    padding-top: 8px;\r\n/*    flex-direction: column;\r\n    justify-content: center;*/\r\n    align-items: center;\r\n    \r\n}\r\n\r\n\r\n#price {\r\n    opacity: 0.9;\r\n    color: #FFF;\r\n    font-family: Rubik;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n}\r\n\r\ndiv#discount-row-2-1 {\r\n    text-align: justify;\r\n    padding: 8px;\r\n}\r\n\r\ndiv#discount-row-2-2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 8px;\r\n}\r\n\r\n#go-to-site {\r\n    border-radius: 50px;\r\n    background:  #31B02E;\r\n    display: flex;\r\n    height: 32px;\r\n    padding: 0px 16px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n    #go-to-site.disabled {\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n        background: #31b02ea8;\r\n        color: #ffffff91;\r\n    }\r\n\r\n@keyframes beat {\r\n    0%, 100% { transform: scale(1); }\r\n    50% { transform: scale(1.1); }\r\n}\r\n\r\n#go-to-site.beatAnimation {\r\n    animation: beat 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55) 1;\r\n    animation-delay: 0.5s;\r\n}\r\n\r\ninput#discount-code {\r\n    border-radius: 50px;\r\n    height: 32px;\r\n    width: 100%;\r\n    padding: 0px 16px;\r\n}\r\n\r\ndiv#discount-code-submit {\r\n    height: 32px;\r\n    border: 1px solid #fff;\r\n    border-radius: 50px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 0px 16px;\r\n    margin-top: 2px;\r\n    margin-left: 8px;\r\n    cursor: pointer;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n \r\n\r\n\r\n\r\n    .reg-form input {\r\n        height: 30px;\r\n    }\r\n\r\n    .passwordEye {\r\n        top: 7px;\r\n    }\r\n\r\n\r\n\r\n    #page2-main-wrapper, #discount-wrapper {\r\n        max-width: 600px;\r\n    }\r\n}\r\n#discount-code::-webkit-outer-spin-button,\n#discount-code::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n#discount-code[type=number] {\n    -moz-appearance: textfield;\n    appearance:textfield;\n}\r\n\r\n@media only screen and (max-width: 374px) {\r\n    .reg-form {\r\n        padding: 0px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
